<div class="card-item shadow-sm" *transloco="let t">
  <div [ngStyle]="{ 'background-color': document.category ? document.category.color : '#999999' }" class="card-header">
    <h6 class="my-0 fw-bold">
      {{ document.title }}
    </h6>
    <img
      *ngIf="document.category"
      [alt]="document.category.name"
      height="30px"
      [src]="materialServer + document.category.inactiveIconUrl"
    />
  </div>
  <div class="card-body">
    <a [href]="document.file" class="card-body-download btn btn-outline-dark" target="_blank">
      <i aria-hidden="true" [class]="icons.download + ' me-2'"></i>
      {{ t('shared/download') }}
    </a>
    <h6 *ngIf="title" class="fw-bold">{{ title }}</h6>
    <img alt="" class="card-body-img" [src]="document.previewImage" />
  </div>
</div>
